import Config from '@/helpers/config'
import axios from 'axios'

function getMyLocation () {
  return new Promise((resolve, reject) => {
    if (typeof window.CACHE_LOCATION !== 'undefined') {
      console.log('this position have been cached')
      resolve(window.CACHE_LOCATION)
    } else {
      console.log('get my location')
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          let result = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
          window.CACHE_LOCATION = result
          resolve(window.CACHE_LOCATION)
        })
      }
    }
  })
}

function getMyLocationWithAddress () {
  return new Promise((resolve, reject) => {
    if (typeof window.CACHE_LOCATION_WITH_ADDRESS !== 'undefined') {
      console.log('this position address have been cached')
      resolve(window.CACHE_LOCATION_WITH_ADDRESS)
    } else {
      console.log('get my location')
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          addressFromLatLng(
            position.coords.latitude,
            position.coords.longitude
          ).then(address => {
            console.log('address', address)
            let result = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
              address: address
            }
            window.CACHE_LOCATION_WITH_ADDRESS = result
            resolve(window.CACHE_LOCATION_WITH_ADDRESS)
          })
        })
      }
    }
  })
}

function addressFromLatLng (lat, lng) {
  var base = 'https://revgeocode.search.hereapi.com'
  var url = `${base}/v1/revgeocode?at=${lat}%2C${lng}&lang=en-US&apikey=${Config.apiKeyHereMap}`
  console.log(url)
  return new Promise((resolve, reject) => {
    axios.get(url).then(response => {
      console.log('response', response)
      if (response.data && response.data.items && response.data.items.length > 0) {
        return resolve(response.data.items[0].title)
      } else {
        return resolve('')
      }
    }).catch(() => {
      return resolve('')
    })
  })

  // return
  // https://revgeocode.search.hereapi.com/v1/revgeocode?at=10.7289839%2C106.7219485&lang=en-US&apikey=9ComSRXwJ8kxxSa1SMtEkPYCsX--3r2We93Q9rhZHGI
}

function getCoordinateFromAddress (address) {
  var base = 'https://geocode.search.hereapi.com/v1/geocode'
  var url = `${base}?q=${address}&lang=en-US&apikey=${Config.apiKeyHereMap}`
  console.log(url)
  return new Promise((resolve, reject) => {
    axios.get(url).then(response => {
      console.log('response', response)
      if (response.data && response.data.items && response.data.items.length > 0) {
        console.log('heey ', response.data.items[0].position)
        return resolve(response.data.items[0].position)
      } else {
        console.log('heey 2')
        return resolve(null)
      }
    }).catch(() => {
      return resolve(null)
    })
  })
}

function getStartIcon () {
  var svgMarkup = '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="50" viewBox="0 0 40 50" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M34.25 31.652A19.015 19.015 0 0 0 39 19.06C39 8.549 30.478 0 20 0S1 8.55 1 19.059c0 4.823 1.795 9.233 4.75 12.593L19.975 46 32.83 33.104c.407-.374 1.419-1.452 1.419-1.452z"/><mask id="c" width="38" height="46" x="0" y="0" fill="#fff"><use xlink:href="#a"/></mask><ellipse id="b" cx="19.807" cy="19.168" rx="12.363" ry="12.197"/><mask id="d" width="25.725" height="25.394" x="-.5" y="-.5"><path fill="#fff" d="M6.944 6.471h25.725v25.394H6.944z"/><use xlink:href="#b"/></mask></defs><g fill="none" fill-rule="evenodd"><ellipse cx="20" cy="45.16" fill="#FFF" stroke="#979797" stroke-width=".25" rx="3.5" ry="3.5"/><use fill="#323232" xlink:href="#a"/><path fill="#7D7D7D" d="M12.011 37.805h15.978l-7.916 8z"/><use stroke="#7C7C7C" stroke-width=".5" mask="url(#e)" xlink:href="#a"/><use stroke="#FFF" stroke-width=".5" mask="url(#c)" xlink:href="#a"/><ellipse fill="#FFF" cx="19.807" cy="19.168" rx="12.363" ry="12.197"/><path fill="#323232" d="M6.812 6.948h6.45v6.364h-6.45zm0 12.727h6.45v6.364h-6.45zm6.45-6.363h6.45v6.364h-6.45zm0 12.727h6.45v6.364h-6.45zm6.45-19.091h6.45v6.364h-6.45zm0 12.727h6.45v6.364h-6.45zm6.45-6.363h6.45v6.364h-6.45zm0 12.727h6.45v6.364h-6.45z"/><use stroke="#FFF" mask="url(#d)" xlink:href="#b" stroke-linecap="square"/></g></svg>'
  return new H.map.Icon(svgMarkup)
}
function getIcon (index) {
  var svgMarkup =
      '<svg width="24" height="24" ' +
      'xmlns="http://www.w3.org/2000/svg">' +
      '<rect stroke="white" fill="#1b468d" x="1" y="1" width="22" ' +
      'height="22" /><text x="12" y="18" font-size="12pt" ' +
      'font-family="Arial" font-weight="bold" text-anchor="middle" ' +
      'fill="white">' +
      (index + 1) +
      '</text></svg>'
  return new H.map.Icon(svgMarkup)
}

export default {
  getMyLocation,
  getMyLocationWithAddress,
  getCoordinateFromAddress,
  getStartIcon,
  getIcon
}



// WEBPACK FOOTER //
// ./src/helpers/location.js